import { render, staticRenderFns } from "./PackageAnalytics.vue?vue&type=template&id=b478a2c2&scoped=true"
import script from "./PackageAnalytics.vue?vue&type=script&lang=js"
export * from "./PackageAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PackageAnalytics.vue?vue&type=style&index=0&id=b478a2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b478a2c2",
  null
  
)

export default component.exports